import { createSelector } from 'reselect'
import * as firebaseSelectors from '../../Core/Firebase/firebase.selectors'

export const getMapState = (state) => state.mars.map
export const getStoryline = (state) => state.storyLine

export const getUserMap = createSelector([getMapState], (map) => {
  return map.userMap
})
export const getAlerts = createSelector([getStoryline], (story) => {
  return story.alerts
})
export const getStoryLineSprites = createSelector([getStoryline], (storyline) => {
  return storyline.sprites
})

export const getStoreSprites = createSelector([getMapState], (map) => {
  return map.sprites
})
export const getBackToRanking = createSelector([getMapState], (map) => {
  return map.backToRanking
})
export const getDisplayingBuildingCard = createSelector([getMapState], (map) => {
  return map.displayingBuildingCard
})
export const getVisitorMap = createSelector([getMapState], (map) => {
  return map.visitorMap
})
export const getVisitorInfo = createSelector(
  [getVisitorMap, firebaseSelectors.getPlayerList],
  (map, playersList) => {
    if (!playersList || !playersList[map.visitorId]) {
      return null
    }
    return {
      ...playersList[map.visitorId],
      id: map.visitorId,
    }
  }
)
export const getVisitorId = createSelector([getVisitorMap], (map) => {
  return map.visitorId
})
export const getAtlas = createSelector([getStoryline], (storyline) => {
  return storyline.atlas
})
export const getAttackState = createSelector([getMapState], (map) => {
  return map.attackState
})
export const getBuildingParameters = createSelector([getStoryline], (storyLine) => {
  return storyLine.buildingParameters
})
export const getMeshModifications = createSelector([getStoryline], (storyLine) => {
  return storyLine.meshModifications
})
export const getSimpleModels = createSelector([getStoryline], (storyLine) => {
  return storyLine.simpleModels
})

export const getAnimations = createSelector([getStoryline], (storyline) => {
  return storyline.animations
})
export const getTerrainVariants = createSelector([getStoryline], (storyline) => {
  if (!storyline || !storyline.atlas || !storyline.atlas.textures) return []
  return Object.keys(storyline.atlas.textures).filter((key) => key != 'mountain')
})
export const getView = createSelector([getMapState], (map) => {
  return map.view
})

export const getSelectedTile = createSelector([getMapState], (map) => {
  return map.selectedTile
})

export const getZooms = createSelector([getMapState], (map) => {
  return map.zoomLevels
})

export const getBuildings = createSelector([getStoryline], (storyline) => {
  return storyline.buildings
})

export const getBuildingTypes = createSelector([getBuildings], (buildings) => {
  if (!buildings) return {}
  
  let types = {}
  Object.values(buildings).forEach((building) => {
    if (!types[building.type]) {
      types[building.type] = 1
    } else {
      types[building.type]++
    }
  })

  return types
})

export const getBuildingSelected = createSelector(
  [getSelectedTile, getUserMap, getVisitorMap],
  (selectedTile, userMap, visitorMap) => {
    let buildings = visitorMap.mapId ? visitorMap.buildings : userMap.buildings
    let key = selectedTile ? selectedTile.q + '_' + selectedTile.r : null
    let found = key ? buildings[key] : null

    return found
  }
)
